import { useTranslation } from '@flecto/translations'
import { type CoreInquiry } from '@flecto/types'
import { Badge } from '@flecto/ui'

export type BadgeInquiryStatusProps = {
  inquiry?: CoreInquiry
}

export function BadgeInquiryStatus({ inquiry }: BadgeInquiryStatusProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'inquiries' })

  if (!inquiry) {
    return null
  }

  switch (inquiry.status) {
    case 'requested':
      return <Badge color='blue'>{t('requested')}</Badge>
    case 'approved':
      return <Badge color='green'>{t('approved')}</Badge>
    case 'rejected':
      return <Badge color='red'>{t('rejected')}</Badge>
    case 'expired':
      return <Badge color='gray'>{t('expired')}</Badge>
    default:
      return null
  }
}
